<template>
  <div>
    <div class="contentbottom-box">
      <div
        class="item"
        @click="$emit('toInfo', item.id)"
        v-for="(item, index) in list.slice(0, 4)"
        :key="index"
      >
        <div class="icon">
          <img :src="getImgUrl(item.thumb)" alt="" />
        </div>
        <div class="title">{{ item.title }}</div>
        <div class="text">{{ item.describe }}</div>
      </div>
    </div>
    <div class="load-more" @click="loadMore">加载更多</div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    dataIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      listData: [
        {
          img: require("@/assets/case/com (4).png"),
          title: "山禾泉品牌设计",
          text: "品牌设计",
        },
        {
          img: require("@/assets/case/com (3).png"),
          title: "思芝谷教育品牌设计",
          text: "品牌设计",
        },
        {
          img: require("@/assets/case/com (2).png"),
          title: "乐讯品牌设计",
          text: "品牌设计",
        },
        {
          img: require("@/assets/case/com (1).png"),
          title: "联瑞科技品牌设计",
          text: "品牌设计",
        },
      ],
    };
  },
  mounted() {
    // console.log("listlistlist", this.list);
  },
  methods: {
    loadMore() {
      this.$router.push({
        name: "phone-caseList",
        query: {
          index: this.dataIndex,
        },
      });
    },
  },
};
</script>
<style scoped>
.contentbottom-box {
  width: 46.875rem;
  background: #0d0d0d;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 0 2.5rem 5rem;
}

.contentbottom-box .item {
  width: 20rem;
}

.contentbottom-box .item .icon {
  width: 20rem;
  height: 14.875rem;
}

.contentbottom-box .item .icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.3125rem;
}

.contentbottom-box .item .title {
  font-weight: 400;
  font-size: 1.75rem;
  color: #ffffff;
  margin: 1.875rem 0 1.25rem 0;
}

.contentbottom-box .item .text {
  font-weight: 400;
  font-size: 1.25rem;
  color: #ffffff;
  opacity: 0.3;
  margin-bottom: 2.1875rem;
}

.load-more {
  font-weight: 400;
  font-size: 1.625rem;
  color: #ffffff;
  text-align: center;
  opacity: 0.5;
  margin-top: -3rem;
  margin-bottom: 6.6875rem;
}
</style>
